<template>
    <div class="article-who">
        <p>
            At <strong>GSC Tanker Care</strong>, we specialise in delivering comprehensive tanker cleaning and waste
            management solutions for the maritime industry. Together with
            <strong>ZHOUSHAN GOLDEN OCEAN TANKER CLEANING</strong>, our sister company, we provide world-class services
            tailored to the needs of shipowners and operators.
        </p>
        <p>
            With years of experience in the industry, we are committed to providing efficient, compliant, and
            environmentally responsible services. Our long-term partnerships with leading shipping companies such as
            Oldendorff Carriers, COSCO, and Maersk demonstrate our reputation for reliability and quality.
        </p>
        <content-subheading heading="Learn More About Our Procedures" headingComponent="h2" marginBottom="mb-6" />
        <p>
            For detailed information about our tanker cleaning and waste management procedures, please download our
            Procedure Details PDF document.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleWho',
};
</script>
